export enum ProductListExportToEmailTemplate {
  CONSERVATIVE = 'conservative',
  CLASSY = 'classy',
  EDGY = 'edgy',
}

export interface ProductListExportToEmailRecipientBody {
  name: string;
  email: string;
}

export interface ProductListExportToEmailProduct {
  productId: string;
  brandId: string;
  imageUrls: string[];
}

export interface ProductListExportToEmailBrandPromote {
  brandId: string;
  brandOrganisationId: string;
}
export interface ProductListExportToEmailPromotesDto {
  accountTypeIds?: string[];
  accountIds?: string[];
  brandOrganisations?: ProductListExportToEmailBrandPromote[];
}

export interface ProductListExportToEmailBody {
  subject: string;
  message?: string;
  recipients: ProductListExportToEmailRecipientBody[];
  promoteReferences: ProductListExportToEmailPromotesDto;
  template: ProductListExportToEmailTemplate;
  configuration?: { [key: string]: string };
  products?: ProductListExportToEmailProduct[];
  amountOfProductsToShow?: number;
}
